var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.182,
    height: 14.646,
    viewBox: "0 0 13.182 14.646",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.591 1.465a2.2 2.2 0 0 0-2.2 2.2v4.39a2.2 2.2 0 0 0 4.394 0V3.662a2.2 2.2 0 0 0-2.194-2.197zm0-1.465a3.662 3.662 0 0 1 3.662 3.662v4.393a3.662 3.662 0 1 1-7.323 0V3.662A3.662 3.662 0 0 1 6.591 0zM0 8.077a.732.732 0 0 1 1.465 0 5.1 5.1 0 0 0 5.1 5.1h.044a5.1 5.1 0 0 0 5.1-5.1.732.732 0 0 1 1.465 0 6.569 6.569 0 0 1-6.569 6.569h-.036A6.569 6.569 0 0 1 0 8.077z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mic.107cb2a4d428bfa31e5529f5b65595fa.svg";